/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Agenda/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Appointments from './Appointments/index'
import MinimiseAction from './MinimiseAction/index'
import React from 'react'
import Tabs from './Tabs/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconEvent from 'DesignSystem/Svgs/TysiaIconEvent/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Agenda({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Agenda"
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Agenda.Vertical"
  data-view-path={viewPath}
 style={{'--bc-5-2jugIJ': dtColorsWhite,'--bc-6-2jugIJ': dtColorsNeutral400,'--mb-7-2jugIJ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--fg-1-2jugIJ': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? 0 : 1,'--fs-2-2jugIJ': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? 0 : 1,'--fb-3-2jugIJ': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? "auto" : "100%",'--w-4-2jugIJ': isMedia.mobile ? "100%" : "250px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Agenda.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-8-2jugIJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-2jugIJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbc-10-2jugIJ': dtColorsNeutral400,'--bc-5-2jugIJ': dtColorsWhite,'--bbw-11-2jugIJ': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? "0px" : "1px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconEvent
  viewPath={`${viewPath}/TysiaIconEvent`}
 width={16}
 height={16}
 fill={dtColorsNeutral900}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 marginLeft={4}
 text="Agenda"
/>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
<MinimiseAction
  viewPath={`${viewPath}/MinimiseAction`}
/>
</div>
<Appointments
  viewPath={`${viewPath}/Appointments`}
/>
</div>
{children}
</React.Fragment>)
}